export default "__VITE_ASSET__Bx9S3MBP__"